var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toptitle"},[(_vm.header.title_url)?_c('a',{staticClass:"title_font2",attrs:{"href":_vm.header.title_url.url||_vm.header.title_url}},[_vm._v(_vm._s(_vm.header.title))]):_c('span',[_vm._v(_vm._s(_vm.header.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }